import {forwardRef, PropsWithChildren, useState} from "react";
import {Screen} from "../Screen/Screen";
import styles from './FeedbackFormScreen.module.scss'
import {clsIf, clss, isEmail} from "../../src/utils";
import {ActionButton} from "../ActionButton/ActionButton";
import * as gtag from "../../src/gtag";
import {sendFormData} from "../../src/forms";
import bckMap from "../../public/images/bck-map.png";
import Image from "next/image";
import bckIconMail from "../../public/images/icons/mail.svg";

export const FeedbackFormScreen = forwardRef<HTMLDivElement, PropsWithChildren<{
  title: string,
  description: string,
  eventLabel: string,
  withMessage?: boolean,
  messageExample?: string,
}>>(({
  title,
  description,
  eventLabel,
  withMessage,
  messageExample,
  children,
}, ref) => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const [emailHasError, setEmailHasError] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(false);
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageHasError, setMessageHasError] = useState(false);

  async function submitForm() {
    gtag.event({
      action: 'submit_form',
      label: eventLabel,
    })

    let hasErrors = false;
    if (!isEmail(email)) {
      setEmailHasError(true)
      hasErrors = true
    }
    if (hasErrors) {
      return;
    }

    setFormSubmitted(true)
    setSending(true);
    try {
      await sendFormData(email, `${eventLabel}_form`, message)
    } catch (e: any) {
      setError(true)
    }
    setSending(false)
  }

  return <Screen wrapperClass={styles.touchWrapper} className={styles.touch} wide={true} ref={ref} backgroundSrc={bckMap}>
    {formSubmitted ? <div className={styles.formSubmittedPlate}>
      <div className={styles.icon} >
        <Image src={bckIconMail} draggable={false} width={40} height={40} alt={''}/>
      </div>
      {
        sending ? <div>...</div> : error ? <div>Woops... Something went wrong. Please try again later, or write directly to <a href="mailto:welcome@satelstories.com">welcome@satelstories.com</a></div> :
          <div>Ahoy! Thanks for reaching out, we’ll answer you as soon as possible</div>
      }
    </div> : (<div className={styles.form}>
      <h3>{title}</h3>
      <div className={styles.description}>{description}</div>
      <label className={clss(clsIf(emailHasError, styles.error))}>
        <span className={styles.labelContent}>Your email</span>
        <input value={email} placeholder={'my-email@example.com'} onChange={(e) => {setEmail(e.target.value); setEmailHasError(false)}}/>
      </label>
      {withMessage && <label className={clss(clsIf(messageHasError, styles.error))}>
        <span className={styles.labelContent}>Message (optional)</span>
        <textarea placeholder={messageExample} value={message} onChange={(e) => {setMessage(e.target.value); setMessageHasError(false);}}/>
      </label>}
      <div className={styles.actionRow}>
        <ActionButton label={'Let’s go!'} onClick={() => submitForm()}/>
      </div>
    </div>)}
  </Screen>
});